import { render, staticRenderFns } from "./EndingPage.vue?vue&type=template&id=101a9ddc&"
import script from "./EndingPage.vue?vue&type=script&lang=ts&"
export * from "./EndingPage.vue?vue&type=script&lang=ts&"
import style0 from "./EndingPage.vue?vue&type=style&index=0&id=101a9ddc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports